<template>
  <div ref="wrapper" :class="{'depth-wrapper-sell': type == 'sell', 'depth-wrapper': type == 'buy'}">
    <div v-if="loading" class="exchange-loading d-flex justify-center align-center">
      <div class="loading-inner">
        <v-progress-circular class="mr-1" color="#ffffff" indeterminate size="25" width="3"></v-progress-circular>
        <span class="loading-text color-fff">{{ $t('labels.loading') }}...</span>
      </div>
    </div>
    <div class="table-layout" :class="reverseIndex ? 'mt-auto' : ''" v-if="!loading && model.length > 0">
      <ol class="wrapper">
        <li
          class="depth-data-item clearfix"
          v-for="(item, index) in model"
          :key="item.price + item.volume + item.amount + index"
          :data-price="item.price"
          @click="onClick(item)"
        >
          <DepthRow
            :ref="item.price"
            :label="label"
            :index="getIndex(index + 1)"
            :price="item.price"
            :propVolume="item.volume"
            :propAmount="item.amount"
            :labelClass="labelClass"
          ></DepthRow>
        </li>
      </ol>
    </div>

    <div class="no-depth-data" v-if="model.length === 0 && !loading">{{ $t('common.noRecords') }}</div>
  </div>
</template>

<script>
import DepthRow from './components/row';
import BigNumber from 'bignumber.js';

export default {
  name: 'DepthComponent',
  components: {
    DepthRow
  },
  props: {
    model: {
      type: Array,
      default: []
    },
    label: String,
    labelClass: String,
    type: String,
    reverseIndex: {
      type: Boolean,
      default: false
    },
    scrollBottomOnLoad: {
      type: Boolean,
      default: false
    },
    onClickCallback: {
      type: Function,
      default: null
    }
  },
  watch: {
    model(value) {
      this.loading = false;
        this.scrollBottom(500);
    }
  },
  methods: {
    // init(data) {
    //   if (null != data && undefined != data) {
    //     if (0 < data.length) {
    //       this.data = data
    //         .map(item => {
    //           return this.createValue(item[0], item[1], item[2]);
    //         })
    //         .filter(item => {
    //           if (new BigNumber(item.volume).isGreaterThan(0)) {
    //             return item;
    //           }
    //         });
    //     }
    //   }

    //   this.mergeQueue();
    //   return;
    // },
    // onMessage(price, volume, amount) {
    //   return this.createQueue(price, volume, amount);
    // },
    // debug(value) {
    //   console.log('DP', this.label, value);
    // },
    // isEmpty() {
    //   if (null == this.data || undefined == this.data) {
    //     return true;
    //   } else {
    //     if (0 >= this.data.length) {
    //       return true;
    //     } else {
    //       return false;
    //     }
    //   }
    // },
    // isSmallest(price) {
    //   let bignumber = new BigNumber(price);
    //   let index = this.data.length - 1;
    //   let target = this.data[index].price;

    //   if (bignumber.isLessThan(target)) {
    //     return true;
    //   }

    //   return false;
    // },
    // isLargest(price) {
    //   let bignumber = new BigNumber(price);
    //   let index = 0;
    //   let target = this.data[index].price;

    //   if (bignumber.isGreaterThan(target)) {
    //     return true;
    //   }

    //   return false;
    // },
    // isBetween(price) {
    //   let bignumber = new BigNumber(price);
    //   let index;

    //   index = this.data.findIndex(item => {
    //     if (new BigNumber(item.price).isLessThan(bignumber)) {
    //       return item;
    //     }
    //   });

    //   if (-1 != index) {
    //     return index;
    //   }

    //   return -1;
    // },
    // insertFromTop(value) {
    //   return this.data.splice(0, 0, value);
    // },
    // insertFromBottom(value) {
    //   return this.data.push(value);
    // },
    // insertBetween(value, index) {
    //   return this.data.splice(index, 0, value);
    // },
    // update(target, value) {
    //   let index = this.data.findIndex(item => {
    //     if (new BigNumber(item.price).isEqualTo(value.price)) {
    //       return item;
    //     }
    //   });

    //   if (-1 != index) {
    //     if (new BigNumber(value.volume).isLessThanOrEqualTo(0)) {
    //       return this.data.splice(index, 1);
    //     } else {
    //       this.data[index].volume = value.volume;
    //       this.data[index].amount = value.amount;
    //       target[0].update(value.volume, value.amount);
    //     }
    //   }

    //   return;
    // },
    // createValue(price, volume, amount) {
    //   if (null == volume || undefined == volume) {
    //     volume = 0;
    //   }

    //   if (null == amount || undefined == amount) {
    //     amount = 0;
    //   }

    //   return {
    //     price: price.toString(),
    //     volume: volume.toString(),
    //     amount: amount.toString()
    //   };
    // },
    // clear() {
    //   this.data = null;
    // },
    // limitRows() {
    //   if (null == this.data || undefined == this.data) {
    //     this.data = [];
    //     return;
    //   }

    //   if (!this.reverseIndex) {
    //     return this.data.slice(0, this.maxRow);
    //   } else {
    //     if (this.data.length > this.maxRow) {
    //       return this.data.slice(this.data.length - this.maxRow);
    //     } else {
    //       return this.data.slice(0, this.maxRow);
    //     }
    //   }
    // },
    getIndex(index) {
      if (this.reverseIndex) {
        let max;
        if (this.maxRow < this.model.length) {
          max = this.maxRow;
        } else {
          max = this.model.length;
        }

        return max - index + 1;
      }
      return index;
    },
    // createQueue(price, volume, amount) {
    //   if (null == this.queue) {
    //     this.queue = {};
    //   }

    //   this.queue[price.toString()] = this.createValue(price, volume, amount);
    //   return;
    // },
    // clearQueue() {
    //   this.queue = null;
    // },
    // mergeQueue() {
    //   if (null != this.queue) {
    //     for (let key in this.queue) {
    //       let item = this.queue[key];
    //       this.updateData(item.price, item.volume, item.amount);
    //     }

    //     this.clearQueue();
    //   }

    //   this.renderData = this.limitRows();
    //   this.hideLoading();
    //   this.startAutoMerge();
    //   this.onMergeEnd(this.data, this.updated);
    //   this.updated = false;
    //   return;
    // },
    startAutoMerge() {
      if (!this.autoMerge) {
        if (this.scrollBottomOnLoad) {
          this.scrollBottom(500);
        }
        this.autoMerge = true;
        this.interval = setInterval(() => {
          this.mergeQueue();
        }, this.autoMergeDelay);
      }
    },
    // onMergeEnd(data, updated) {
    //   return;
    // },
    // hideLoading() {
    //   this.loading = false;
    // },
    // showLoading() {
    //   this.loading = true;
    // },
    // updateData(price, volume, amount) {
    //   if (null == this.data || undefined == this.data) {
    //     this.data = [];
    //   }

    //   let component = this.$refs[price];
    //   let value = this.createValue(price, volume, amount);
    //   this.updated = true;

    //   if (null == component || undefined == component || 0 >= component.length) {
    //     if (this.inDataSet(value)) {
    //       return;
    //     }

    //     if (new BigNumber(value.volume).isLessThanOrEqualTo(0)) {
    //       return;
    //     }

    //     if (this.isEmpty()) {
    //       return this.insertFromBottom(value);
    //     }

    //     if (this.isSmallest(price)) {
    //       if (this.type === 'sell') {
    //         this.$parent.$parent.$refs.exchangeForm.$refs.lastSellPrice = price;
    //       }
    //       return this.insertFromBottom(value);
    //     }

    //     if (this.isLargest(price)) {
    //       if (this.type === 'buy') {
    //         this.$parent.$parent.$refs.exchangeForm.$refs.lastBuyPrice = price;
    //       }
    //       return this.insertFromTop(value);
    //     }

    //     let index = this.isBetween(price);
    //     if (-1 != index) {
    //       return this.insertBetween(value, index);
    //     }
    //   } else {
    //     this.update(component, value);
    //   }
    //   return;
    // },
    // inDataSet(value) {
    //   let data = this.data;

    //   if (new BigNumber(value.volume).isLessThanOrEqualTo(0)) {
    //     for (let i = 0; i < data.length; i++) {
    //       let item = data[i];
    //       if (item.price == value.price) {
    //         data.splice(i, 1);
    //         this.data = data;
    //         return true;
    //       }
    //     }
    //   } else {
    //     for (let i = 0; i < data.length; i++) {
    //       let item = data[i];
    //       if (item.price == value.price) {
    //         data[i].volume = item.volume;
    //         data[i].amount = item.amount;
    //         this.data = data;
    //         return true;
    //       }
    //     }
    //   }
    //   return false;
    // },
    // getQueue() {
    //   return this.queue;
    // },
    // reset() {
    //   clearInterval(this.interval);
    //   this.showLoading();
    //   this.data = null;
    //   this.queue = null;
    //   this.interval = null;
    //   this.autoMerge = false;
    // },

    //events
    onClick(price) {
      if (this.onClickCallback && 'function' == typeof this.onClickCallback) {
        this.onClickCallback(price);
      }
      return;
    },
    scrollBottom(delay) {
      if (this.type == 'sell') {
        setTimeout(() => {
          this.$refs.wrapper.scrollTop = this.$refs.wrapper.scrollHeight;
        }, delay);
      }
    }
  },
  data() {
    return {
      renderData: null,
      data: null,
      loading: true,
      queue: null,
      interval: null,
      autoMerge: false,
      autoMergeDelay: 500,
      maxRow: !window.env.maxDepthRow ? 20 : window.env.maxDepthRow,
      updated: false
    };
  }
};
</script>

<style scoped>
.depth-wrapper {
  height: calc((100% - 113px) / 2);
  display: flex;
  overflow: hidden;
  position: relative;
  padding-top: 5px;
  padding-bottom: 5px;
}

.depth-wrapper-sell {
  height: calc((100% - 115px) / 2);
  display: flex;
  overflow: hidden;
  position: relative;
  padding-top: 0px;
  padding-bottom: 5px;
}

.table-layout {
  width: 100%;
}

.exchange-loading {
  width: 100%;
}

.no-depth-data {
  color: #7a838f;
  margin: auto;
}

.mt-auto {
  margin-top: auto;
}
</style>
